// L'icône d'un type d'appareil, pour reconnaître une ligne d'un coup d'œil (icônes PrimeIcons).
const TYPE_ICONS: Record<string, string> = {
  pos: 'pi-calculator',
  kiosk: 'pi-tablet',
  pds: 'pi-desktop',
  print_agent: 'pi-server',
  printer: 'pi-print',
  scale: 'pi-gauge',
  payment_terminal: 'pi-credit-card',
  wifi_bridge: 'pi-wifi',
  ip_scanner: 'pi-qrcode',
  usb_scanner: 'pi-barcode',
  cash_drawer: 'pi-wallet',
};

export const typeIcon = (type: string): string =>
  TYPE_ICONS[type] ?? 'pi-microchip';
